var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_398_817",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_398_817",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAADkklEQVR4nO3dTWhUVxiH8efMVCUW8RsCtptqErNQQZrUQnHVRRdx4UKhq4hBEt0F9+LXTtAuSjQidFErqJuu2lIKbcWFFF3UiNFERfxEMGqQkBI793QRhIK5Q+6ZczLvmP9veWfuew/3IZk7MyEXRERERERERMQOl2RqW99uPPuBNqCc5BgmuQnwVyhl/dw6PRQ0IfaSaOvtwbsz0ec2lnEqpQ3cHXhYdMdS9KV4tz/6zMazlHK2O2TH+EGgNcHMRrQ+ZKcUQebRa0ZVQechRRCpgYIYoyDGKIgxCmKMghijIMYoiDEKYoyCGKMgxiiIMQpijIIYoyDGKIgxCmKMghijIMYoiDEKYoyCGKMgxiiIMQpijIIYoyDGKIgxCmKMghijIMYoiDEKYoyCGKMgxiiIMQpijIIYoyDGKIgxCmKMghijIMYoiDEKYoyCGKMgxiiIMR8UevbafR9TznqYd//ccu7MPkjb3o347BKwNN1yZPa/srw/jmIkV+A1xG1Jtwx5q0AQ/2G6ZchbusoyRkGMKXbZO7OLjJzaGWHO3GvtuwDsqPcy/k8/IcYoiDFFglRyti+MsZD3UN75qqpIkImZN7vmkAPPA69DdioS5MnMm/0ncFC/+t6Vc76qK3Iih3O2r2bds86QgxvgE86+FbJTkXfql3MfcnSHHLzuPGPJZmf/5p+vKgp8uFj+Ofcx53to720JWUBdOR4kmnydO2cehew4+yCjA8PA1ZxHF1BxZ/movylkEXXj/G9J5nr/feiuxV6MvTtR5dFOFk/+0FBRbg9eAz8Seeo4b5qCb4pWLMjo8/NAtdvBbWfx5J+s39Mo96HyOHc48sRj3P/mVejuBb+GvelZ3fk33u8iP+YafKmPVZ+uYXnHc150PYE/Ul7N1Gbs6g1WdWxm+mvpWt3EL+jmxV9Bbwoh9D6Grb0HwB2a5bPHgFHgGTAVdLz0lgNf1jjjJWX/GcODo7UMCb2xpKO17zto0Mvd+DLw2xgZ/KnWQaHvsD1Lsj04ztW6gPfAFI6vY8SAWv6U5+m1jLGuH1n5OgO3lfn5yfFjHNu4feqXWAPj3At3Xe/nlNxJYFOUefZNgfuWRRxl6OTLmIMj3px4R5mWFTtxrh/oiDfXlElwF6m4I9wduJPiAGlu392yrx2XfQXuC/DtQDOwLNnx0viH6SvE+3iuU3K/86byK/dOj9d7YSIiIiIiIiIyV/4DbuyrpaIo1NsAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotice);
export default __webpack_public_path__ + "static/media/notice.3fc3d485db4d3eff21cd0d24ad4d51aa.svg";
export { ForwardRef as ReactComponent };